// TODO(tsgo): Remove when microsoft/typescript-go#1034 is fixed (check after tsgo 7.1+)
import { clearListingImages } from "./schema/listing-images/clear-listing-images";
import { getAvailableListingImages } from "./schema/listing-images/get-available-listing-images";
import { updateListingImages } from "./schema/listing-images/update-listing-images";
import { updateVariantListingImages } from "./schema/listing-images/update-variant-listing-images";
import { disableListing } from "./schema/listing-management/disable-listing";
import { enableListing } from "./schema/listing-management/enable-listing";

export const groupG = {
  clearListingImages,
  getAvailableListingImages,
  updateListingImages,
  updateVariantListingImages,
  disableListing,
  enableListing,
};
